const enTranslation = {
  Auth: {
    NoPermission: 'You do not have permissions to access this app. Please contact Admin.',
    AdminDirectLoginBlocked: 'Please log in to your account at',
  },
  backgroundUpload: {
    maxLimit: 'Maximum limit reached for manual upload. Please wait for some time and try again later',
  },
  basicInformation: {
    dateOfBirth: 'Date of Birth',
    duplicateWorkerModal: {
      addNewWorker: 'Add new worker',
      badgeNumber: 'Badge Number',
      dateOfBirth: 'Date of Birth',
      primaryEmail: 'Primary Email',
      primaryPhone: 'Primary Phone Number',
      proceedWithSelected: 'Proceed with selected worker',
      secondaryEmail: 'Secondary Email',
      secondaryPhone: 'Secondary Phone Number',
      title: 'Matching Profiles',
    },
    email: 'Email',
    errors: {
      atLeastOneMandatory: 'At least one more field is required: Email, Mobile Number, or Date of Birth.',
      emailRequired: 'Email is required.',
      firstNameRequired: 'First Name is required.',
      invalidDate: 'Please enter a valid date.',
      invalidEmail: 'Please enter a valid Email.',
      invalidPhoneNumber: 'Please enter a valid Mobile Number.',
      lastNameRequired: 'Last Name is required.',
      phoneNumberRequired: 'Mobile Number is required.',
    },
    firstName: 'First Name',
    lastName: 'Last Name',
    phoneNumber: 'Mobile Number',
    subtitle: 'Enter your basic information',
    title: 'Worker Registration',
    unverifiedWorkerWarning: 'You have to register as an unverified worker at the jobsite.',
  },
  biometricConsent: {
    acceptText:
      'By checking the box below, I give my consent as a written release for FCA to collect, capture, store, transmit, maintain, process, derive and use my personal biometric information as described above.',
    consentText:
      'My information may be collected, captured, obtained, stored, and used by Field Control Analytics (“FCA”) and for identification purposes (collectively, the “Data Users”). FCA may collect, capture, obtain, store, transmit, maintain, process, derive, and use my biometric information for its use related to the Services or for identification and credentialing. This information includes personal information and biometric information such as digital photograph. Facial recognition, the virtual comparison of your facial images when logging into the FCA mobile application for allowing access to the online training platform or to tracking your progress through the training and recording your assessment results may be used. My information will be retained by FCA until I request, in writing, that FCA delete such information. I may contact an FCA representative to request removal of my information from FCA’s database. By consenting to the collection and use of this information, I acknowledge and agree that FCA, and its representatives, may use and share biometric information for the purposes listed above.',
    errors: {
      consentRequired: 'Please accept the biometric consent form.',
      failedToAccept: 'Failed to accept biometric consent form.',
    },
    title: 'Biometric Consent',
  },
  registrationConsent: {
    termsCheckbox: 'I have read and agree to the Terms & Conditions',
    authorizationCheckbox: 'I have read and agree to the FCA Authorization Regarding Credentialing and Analytics',
    biometricCheckbox: 'I have read and agree to the Biometric Consent',
    applySignatureTitle: 'Apply Signature',
    applySignatureSubtext: 'Apply the signature you provided during account registration.',
  },
  registrationSignature: {
    title: 'Your Signature',
    subtitle: 'Sign once to confirm all three agreements',
    summary: {
      heading: 'By signing below, you confirm you have read and agreed to:',
      statement1:
        'Your signature will be applied to consent forms on all projects you are assigned to, covering the agreements above.',
      statement2:
        'You can update your signature at any time from your profile settings. Any updated signature will apply to future project assignments.',
      statement3:
        'On some projects you will be assigned first and must accept before a badge is issued. On others you will be activated automatically but will always retain the option to decline the project.',
      statement4:
        'Some projects may require additional information from you. You will be asked to provide these individually for each project.',
    },
    canvasPlaceholder: 'Draw your signature here',
    disclaimer:
      'By signing this document with an electronic signature, I agree that such signature will be as valid as handwritten signatures to the extent allowed by local law.',
    clear: 'Clear Signature',
    back: 'Back',
    next: 'Next',
  },
  capturePhoto: {
    buttons: {
      proceed: 'Proceed',
      retake: 'Retake',
    },
    convertingText: 'Converting image...',
    errorReasons: 'This may happen because of following reasons',
    errors: {
      allFilesRejectedMixed:
        '{{invalidTypeCount}} invalid file type(s) and {{oversizedCount}} file(s) exceeded 5 MB size limit.',
      conversionFailed: 'Unable to convert image into jpeg format.',
      fileSizeExceeded: 'The selected image exceeds the 5 MB size limit. Please choose a smaller image.',
      invalidFileType: 'Invalid file type. Please select an image file (JPEG, PNG, or HEIC).',
      multipleFilesInvalidTypeOnly:
        '{{validCount}} image(s) selected. {{invalidTypeCount}} invalid file type(s) were rejected.',
      multipleFilesSelected:
        '{{validCount}} image(s) selected. {{rejectedCount}} image(s) exceeded the 5 MB size limit and were not selected.',
      multipleFilesWithInvalidTypes:
        '{{validCount}} image(s) selected. {{invalidTypeCount}} invalid file type(s) and {{oversizedCount}} file(s) exceeded 5 MB were rejected.',
      noAccessToCamera: 'No access to camera',
      noWebcam: 'Your device has no webcam',
      photoUploadFailed: 'Failed to Upload Photo.',
      webcamDisabled: 'Your device webcam is blocked',
      webcamOff: 'Your device webcam is turned off',
    },
    title: 'Capture Photo',
    faceValidation: {
      faceCentered: 'Face Centered',
      headStraight: 'Head Straight',
      goodLighting: 'Good Lighting',
      clearNoBlur: 'Clear / No Blur',
      eyesVisible: 'Eyes Visible',
      faceClearlyVisible: 'Face Clearly Visible',
      singleFaceDetected: 'Single Face Detected',
      correctDistance: 'Correct Distance',
    },
  },
  certifications: {
    addModal: {
      certificationGroup: 'Select Certification Group',
      certificationId: 'Certification ID',
      certificationIdPlaceholder: 'Enter certification ID',
      description: 'Description',
      descriptionPlaceholder: 'Enter description',
      exempted: 'exempted',
      certificationIdRequired: 'Certification ID is required',
      descriptionRequired: 'Description is required',
      expirationDate: 'Expiration Date',
      expirationDateRequired: 'Expiration Date is required',
      issueDate: 'Issue Date',
      issueDateRequired: 'Issue Date is required',
      mediaRequired: 'At least one image is required',
      otherGroup: 'Other',
      title: 'Add Certification',
      type: 'Type',
      typeRequired: 'Type is required',
    },
    addNewCertificate: 'Add New Certificate',
    certificationId: 'Certification ID',
    deleteCertificateModal: {
      aboutToDelete: 'You are about to delete your',
      certification: 'certification.',
      errors: {
        failedToDelete: 'Failed to Delete Certification.',
      },
      mayAffectBadge: 'It may affect your badge status.',
      title: 'Are you sure?',
    },
    description: 'Description',
    editModal: {
      title: 'Edit Certification',
    },
    errors: {
      failedToAdd: 'Failed to add certification',
      failedToLoadData: 'Failed to load certification data',
      failedToLoadDetails: 'Failed to load certification details',
      failedToSave: 'Failed to save certification',
      failedToUpdate: 'Failed to update certification',
    },
    expirationDate: 'Expiration Date',
    fcaEffectiveFrom: 'Effective from {{date}}',
    fcaGracePeriodPreactiveWorkerPeriodText:
      'Must be added within {{gracePeriodInDays}} days from badge activation and before the mandatory date of {{date}}',
    fcaGracePeriodText: 'Must be added within {{gracePeriodInDays}} days from badge activation.',
    issueDate: 'Issue Date',
    next: 'Next: Consent Form',
    subtitle: 'Add Certification',
    title: 'Certifications',
    warning: {
      allThe: 'all the',
      atLeastOneOfThe: 'at least one of the',
      cancel: 'Cancel',
      certifications: 'certifications',
      clickViewMore: 'Click on View More to see the list of required certifications',
      consequenceText:
        "If you don't add required certifications, you will not be able to get a badge until they are added. You will be able to login to your profile and add them later if you can't do it now.",
      pleaseAdd: 'Please add',
      proceedAnyway: 'Proceed Anyway',
      requiredCertifications: 'Required Certifications',
      title: 'Certification Warning',
      viewMore: 'View More',
    },
  },
  common: {
    addImage: 'Add an Image',
    addInput: 'Add $INPUT_VALUE',
    back: 'Back',
    cancel: 'Cancel',
    clearAll: 'Clear All',
    close: 'Close',
    confirm: 'Confirm',
    contactUs: 'Contact Us',
    delete: 'Delete',
    done: 'Done',
    download: 'Download',
    edit: 'Edit',
    fieldRequired: '{{field}} is required',
    help: 'Help',
    loadingImages: 'Loading images...',
    more: 'more',
    myAccount: 'My Account',
    next: 'Next',
    offlineError: 'Your device is offline. Please connect to the internet and try again.',
    orSmall: 'or',
    otherValue: 'Other ({{value}})',
    privacyPolicy: 'Privacy Policy',
    save: 'Save',
    selectAll: 'Select All',
    selectedValues: 'Selected Values',
    sessionExpired: 'Your session has expired please log in again.',
    update: 'Update',
    verify: 'Verify',
    warning: 'Warning!',
    yes: 'Yes',
    saveChanges: 'Save Changes',
    here: 'here',
    stableInternetRequired: 'This page requires a stable Internet connection to load and save data.',
    images: 'Images',
  },
  confirmResetPassword: {
    buttons: {
      backToSignIn: 'Go back to Sign-In',
      continue: 'Continue',
    },
    confirmPassword: 'Confirm Password',
    errors: {
      confirmPasswordMismatch: 'Passwords do not match.',
      confirmPasswordRequired: 'Confirm Password is required.',
      invalidPassword: 'Please enter a valid password.',
      passwordRequired: 'Password is required.',
    },
    expiredLinkMessage: 'This link has been expired.',
    password: 'Password',
    subtitle: 'Enter your new password',
    successMessage: 'Password has been reset successfully',
    title: 'Reset Password',
  },
  consentForm: {
    badgeSkippable: {
      goBack: 'Go Back',
      provideNowOrLater: 'You can provide this information now or do it later.',
    },
    skippedFields: {
      back: 'Back',
      message:
        'You have skipped filling out {{fields}}. Please go back and provide the required information before signing the consent form.',
      title: 'Warning',
    },
    offlineSubmitSuccess: 'Consent forms saved. They will upload when you are back online.',
    registrationSuccess: 'Congratulations, you have successfully registered!',
    step1: {
      next: 'Fill Out Consent Form',
      projectAccepted: 'You have accepted this project!',
      projectAddress: 'Project Address',
      projectName: 'Project Name',
      title: 'Project Information',
    },
    step2: {
      completeRegistration: 'Complete Registration',
      customFields: 'Custom Fields',
      storedFields: 'Stored Fields',
      errors: {
        invalidPhoneNumber: 'Please enter a valid Mobile Number.',
        invalidSSN: 'Please enter valid last 4 digits of SSN',
      },
      sectionEntries: '{{count}} entries',
      sectionEntry: '{{count}} entry',
      standardFields: 'Standard Fields',
      subtitle: 'Enter your consent Information',
      title: 'Consent Form',
    },
    step3: {
      sign: 'Sign Consent Form',
    },
  },
  consentFormInformation: {
    customFields: 'Custom Fields',
    customFormChip: 'Custom',
    emergencyContactName: 'Contact Name',
    emergencyContactPhone: 'Contact Phone',
    projectInformation: 'Project Information',
    projectName: 'Project Name',
    selectEmployerError: 'Please select an employer to view the consent form information',
    standardFields: 'Standard Fields',
    standardFormChip: 'Standard',
    storedFields: 'Stored Fields',
    workerTrades: 'Worker Trades',
  },
  contactInformation: {
    contactInfo: {
      alternatePhone: 'Alternate Phone',
      email: 'Email',
      mobileNumber: 'Mobile Number',
      title: 'Contact Information',
    },
    emergencyContact: {
      mobileNumber: 'Mobile Number',
      modalMobileNumber: 'Emergency Mobile Number',
      modalName: 'Emergency Name',
      modalRelationship: 'Emergency Relationship',
      name: 'Name',
      relationship: 'Relationship',
      title: 'Emergency Contact',
    },
    errors: {
      addressLine1Required: 'Address Line 1 is required.',
      addressLine2Required: 'Address Line 2 is required.',
      alternatePhoneRequired: 'Alternate Phone is required.',
      cityRequired: 'City is required.',
      contactMethodRequired: 'Either Email or Mobile Number is required.',
      countryRequired: 'Country is required.',
      emailInvalid: 'Please enter a valid email address.',
      emailRequired: 'Email is required.',
      emergencyContactNameRequired: 'Emergency Contact Name is required.',
      emergencyContactNumberRequired: 'Emergency Contact Number is required.',
      emergencyContactRelationshipRequired: 'Emergency Contact Relationship is required.',
      phoneInvalid: 'Please enter a valid mobile number.',
      phoneRequired: 'Mobile Number is required.',
      stateRequired: 'State is required.',
      zipCodeRequired: 'ZIP Code is required.',
    },
    homeAddress: {
      addressLine1: 'Address Line 1',
      addressLine2: 'Address Line 2',
      borough: 'NYC Borough',
      city: 'City',
      country: 'Country',
      county: 'County',
      state: 'State',
      title: 'Home Address',
      zipCode: 'ZIP Code',
    },
    next: 'Next: Trades',
    subtitle: 'Enter your contact Information',
    title: 'Contact Information',
  },
  courses: {
    actions: {
      myCertifications: 'My Certifications',
      myProjects: 'My Projects',
      sort: 'Sort',
    },
    emptyState: {
      active: {
        subtitle: "You don't have any active courses.",
        title: 'No Active Courses',
      },
      default: {
        subtitle: 'There are no courses to display at this time.',
        title: 'No Courses Available',
      },
      expired: {
        subtitle: "You don't have any expired courses.",
        title: 'No Expired Courses',
      },
    },
    fields: {
      completionDate: 'Completion Date',
      exemptedFor: 'Exempted for',
      expirationDate: 'Expiration Date',
      requiredFor: 'Required for',
    },
    sort: {
      completionDateNewToOld: 'Sort By Completion: New to Old',
      completionDateOldToNew: 'Sort By Completion: Old to New',
      expirationDateNewToOld: 'Sort By Expiration: New to Old',
      expirationDateOldToNew: 'Sort By Expiration: Old to New',
      nameAtoZ: 'Sort By Name: A to Z',
      nameZtoA: 'Sort By Name: Z to A',
    },
    tabs: {
      active: 'Active Courses',
      expired: 'Expired Courses',
    },
    loadingNotice: 'It may take up to 5 minutes for your courses to load. Please be patient.',
    title: 'My Courses',
  },
  createPassword: {
    buttons: {
      createAccount: 'Create Account',
    },
    confirmPassword: 'Confirm Password',
    errors: {
      confirmPasswordMismatch: 'Both passwords should match.',
      confirmPasswordRequired: 'Confirm Password is required.',
      invalidPassword: 'Please enter valid password.',
      passwordRequired: 'Password is required.',
    },
    password: 'Password',
    passwordMatcher: {
      rules: {
        length: 'Be a minimum of 8-15 characters',
        lowerCase: 'Include at least one lower case (a-z)',
        noSpaces: 'Should not have spaces',
        notUsername: 'Your username and password cannot be same',
        number: 'Include at least one number (0-9)',
        special: 'Include at least one special character (!, &,$)',
        title: 'Password must:',
        upperCase: 'Include at least one upper case (A-Z)',
      },
    },
    subtitle: 'Enter your password',
    title: 'Create Password',
  },
  header: {
    adminMode: 'Admin Mode',
    goToProjects: 'Go to projects',
    logout: 'Logout',
    loggingOut: 'Logging out',
    supervisorMode: 'Supervisor Mode',
    myProfile: 'My Profile',
  },
  help: {
    description: 'If you are experiencing issues in Tablet Experience,\nYou can contact us on',
    descriptionMobile: 'If you are experiencing issues in Tablet Experience,You can contact us on',
    phoneHours: '(Monday to Friday from 06:00AM to 06:00PM CST)',
    title: 'Help',
  },
  login: {
    buttons: {
      login: 'Login',
    },
    email: 'Email',
    errors: {
      emailRequired: 'Email is required.',
      invalidEmail: 'Please enter a valid Email.',
      invalidPassword: 'Please enter valid password.',
      invalidPhoneNumber: 'Please enter a valid Mobile Number.',
      passwordRequired: 'Password is required.',
      phoneNumberRequired: 'Mobile Number is required.',
    },
    forgotPassword: 'Forgot Password?',
    loginTitle: 'Login',
    loginWithEmail: 'Login with Email',
    loginWithPhone: 'Login with Phone',
    multipleCompaniesTitle: 'Select Company',
    password: 'Password',
    phoneNumber: 'Mobile Number',
    selectCompany: 'Select Company',
    subtitle: 'Enter your login information',
    title: 'Worker Login',
    companyAdminsWarning: 'Company Admins can log in only',
  },
  myCertifications: {
    actions: {
      addCertification: 'Add Certification',
      filter: 'Filter',
      myCourses: 'My Courses',
      myProjects: 'My Projects',
      sort: 'Sort',
    },
    card: {
      addCertificate: 'Add Certificate',
      allMandatory: 'All mandatory',
      atLeastOneMandatory: 'Atleast one mandatory',
      certificationId: 'Certification ID',
      description: 'Description',
      expirationDate: 'Expiration Date',
      issueDate: 'Issue Date',
      notMandatory: 'Not mandatory',
      projectRequired: 'Project Required',
      uploadNew: 'Upload New',
      viewDetails: 'View Details',
    },
    contextMenu: {
      delete: 'Delete',
      edit: 'Edit',
      viewDetails: 'View Details',
    },
    details: {
      certifications: ' certifications',
      optional: 'Optional',
      pleaseAddAll: 'Please add all the',
      pleaseAddAtLeastOne: 'Please add at least one of the',
      title: 'Certification Details',
    },
    emptyState: {
      current: {
        subtitle: "You don't have any current certifications. Add your certifications to get started.",
        title: 'No Current Certifications',
      },
      default: {
        subtitle: 'There are no certifications to display at this time.',
        title: 'No Certifications Available',
      },
      expired: {
        subtitle: "You don't have any expired certifications. Keep your certifications up to date!",
        title: 'No Expired Certifications',
      },
      required: {
        subtitle: "You don't have any required certifications at the moment.",
        title: 'No Required Certifications',
      },
    },
    filter: {
      clearAll: 'Clear All',
      noRelatedProject: 'No Related Project',
      noResults: 'No results found',
      search: 'Search',
      selectAll: 'Select All',
      title: 'Filter',
    },
    sort: {
      dateNewToOld: 'Sort By Last Updated Date: New to Old',
      dateOldToNew: 'Sort By Last Updated Date: Old to New',
      nameAtoZ: 'Sort By Name: A to Z',
      nameZtoA: 'Sort By Name: Z to A',
    },
    tabs: {
      current: 'Current',
      expired: 'Expired',
      required: 'Required',
    },
    title: 'My Certifications',
  },
  myDrugTesting: {
    title: 'Drug Testing',
    tabs: {
      appointments: 'View Appointments',
      thirdPartyResults: 'View Third-Party Test Results',
    },
    actions: {
      bookAppointment: 'Book Appointment',
      uploadResults: 'Upload Results',
      viewMore: 'View More',
      viewLess: 'View Less',
    },
    uploadResults: {
      title: 'Upload Results',
      editTitle: 'Edit Results',
      selectProject: 'Select Project',
      enterTestDate: 'Enter Test Date',
      facilityName: 'Facility Name',
      panel: 'Panel',
      type: 'Type',
      reason: 'Reason',
      result: 'Result',
      selectPanelFirst: 'Please select a panel first',
      resultOptions: {
        negative: 'Negative',
        batPass: 'BAT Pass',
      },
      confirm: 'Confirm',
      successMessage: 'Results uploaded successfully',
      updateSuccessMessage: 'Results updated successfully',
      upload: {
        hintPrefix: 'Tap here to',
        hint: 'Upload File',
        maxFiles: '(You can upload {{count}} files max)',
      },
      errors: {
        projectRequired: 'Project is required',
        testDateRequired: 'Test Date is required',
        facilityNameRequired: 'Facility Name is required',
        panelRequired: 'Panel is required',
        typeRequired: 'Type is required',
        reasonRequired: 'Reason is required',
        resultRequired: 'Result is required',
        filesRequired: 'Please upload at least one file',
        fileTooLarge: 'Each file must be {{size}} MB or smaller',
        invalidFileType: 'Only PDF, PNG, JPG, and JPEG files are allowed',
        filesUploadFailed: '{{count}} file(s) failed to upload. Please try saving again to retry.',
      },
    },
    bookAppointment: {
      title: 'Book Appointment',
      editTitle: 'Edit Appointment',
      selectProject: 'Select Project',
      selectFacility: 'Select Testing Facility',
      selectPanel: 'Select Testing Panel',
      selectType: 'Select Testing Type',
      reason: 'Reason',
      selectDate: 'Select Appointment Date',
      confirm: 'Confirm',
      facilityInformation: 'Facility Information',
      facilityAddress: 'Facility Address',
      hoursOfOperation: 'Hours of Operation',
      successMessage: 'Appointment booked successfully',
      updateSuccessMessage: 'Appointment updated successfully',
      errors: {
        projectRequired: 'Project is required',
        facilityRequired: 'Testing Facility is required',
        panelRequired: 'Testing Panel is required',
        typeRequired: 'Testing Type is required',
        reasonRequired: 'Reason is required',
        dateRequired: 'Appointment Date is required',
      },
    },
    card: {
      address: 'Address',
      attachments: 'Attachments:',
      batResult: 'BAT Result',
      company: 'Company',
      details: 'Details',
      panel: 'Panel',
      project: 'Project',
      reason: 'Reason',
      resultsStatus: 'Results Status',
      status: 'Status',
      substance: 'Substance',
      testResult: 'Test Result',
      type: 'Type',
    },
    contextMenu: {
      delete: 'Delete Results',
      deleteAppointment: 'Delete',
      edit: 'Edit',
      editResults: 'Edit Results',
    },
    status: {
      pending: 'Pending',
      approved: 'Approved',
      denied: 'Denied',
    },
    appointmentStatus: {
      scheduled: 'Scheduled',
      inProgress: 'In Progress',
      missedAppointment: 'Missed Appointment',
      tested: 'Tested',
      noShow: 'No Show',
      pending: 'Pending',
      approved: 'Approved',
      denied: 'Denied',
      unknown: 'Unknown',
    },
    resultLabels: {
      notSet: 'Not Set',
      negative: 'Negative',
      nonConclusive: 'Non-Conclusive',
      invalid: 'Invalid',
      sentToLab: 'Sent to Lab',
      noShow: 'No Show',
      cancelledByWorker: 'Cancelled by Worker',
      batPass: 'BAT Pass',
      batFail: 'BAT Fail',
      positive: 'Positive',
      lostInTransit: 'Lost in Transit',
      leakDuringTransit: 'Leak During Transit',
      fatalFlaw: 'Fatal Flaw',
      other: 'Other',
    },
    invalidResultTypes: {
      insufficientSampleAmount: 'Insufficient Sample Amount',
      refusalToProvideASample: 'Refusal to Provide a Sample',
      outOfTemperatureRange: 'Out of Temperature Range',
      adulteratedSample: 'Adulterated Sample',
    },
    deleteResultModal: {
      title: 'Are you sure?',
      message: 'You are about to delete this drug test result.',
      successMessage: 'Test result deleted successfully',
      errors: {
        failedToDelete: 'Failed to delete drug test result.',
      },
    },
    deleteAppointmentModal: {
      title: 'Are you sure?',
      message: 'Are you sure you want to delete this appointment?',
      successMessage: 'Appointment deleted successfully',
      errors: {
        failedToDelete: 'Failed to delete appointment.',
      },
    },
    emptyState: {
      appointments: {
        title: 'No Appointments',
        subtitle: "You don't have any drug testing appointments scheduled.",
      },
      thirdPartyResults: {
        title: 'No Third-Party Test Results',
        subtitle: "You don't have any third-party drug test results uploaded.",
      },
    },
  },
  myProfile: {
    title: 'My Profile',
    profilePicture: {
      menu: {
        capturePhoto: 'Capture a Photo',
        uploadFromDevice: 'Upload from Device',
        seeGallery: 'See Gallery',
      },
      gallery: {
        title: 'Image Gallery',
        photo: 'Photo',
        current: 'Current',
        loadError: 'Failed to load gallery.',
        empty: 'No photos available.',
      },
    },
    tabs: {
      profileInformation: 'Profile Information',
      loginInformation: 'Login Information',
      changePassword: 'Change Password',
      createPassword: 'Create Password',
    },
    loginInformation: {
      email: {
        title: 'Email Addresses',
        addButton: 'Add Email',
        columnLabel: 'Email Address',
        placeholder: 'Enter new email address',
        empty: 'No email added',
        note: 'You can add multiple email addresses to your account. The Primary email will be used for login and important notifications. Click "Make Primary" to change your login email, or "Remove" to delete an email address.',
      },
      mobile: {
        title: 'Mobile Numbers',
        addButton: 'Add Mobile',
        columnLabel: 'Mobile Number',
        placeholder: 'Enter mobile number',
        empty: 'No mobile added',
        note: 'You can add multiple mobile numbers to your account. The Primary mobile will be used for login and important notifications. Click "Make Primary" to change your login mobile, or "Remove" to delete a mobile number.',
      },
      table: {
        statusColumn: 'Status',
        actionsColumn: 'Actions',
        primaryBadge: 'PRIMARY',
        secondaryBadge: 'SECONDARY',
        makePrimary: 'Make Primary',
        verify: 'Verify',
        remove: 'Remove',
      },
      add: 'Add',
      errors: {
        emailRequired: 'Email address is required',
        invalidEmail: 'Please enter a valid email address',
        mobileRequired: 'Mobile number is required',
        invalidMobile: 'Please enter a valid mobile number',
      },
      toasts: {
        contactAdded: 'Contact added successfully',
        primaryUpdated: 'Primary contact updated successfully',
        contactRemoved: 'Contact removed successfully',
      },
      enterPasswordModal: {
        title: 'Enter Password',
        addDescriptionPrefix: 'Please enter your password to add',
        addDescriptionSuffix: 'to your account.',
        makePrimaryContactPrefix: 'Changing',
        makePrimaryContactSuffix: 'into the primary {{contactLabel}}.',
        makePrimaryInfo:
          'Allowing this will enable this {{contactTypeLabel}} for account access. You will be able to use this {{contactTypeLabel}} as your username when logging in.',
        makePrimaryWarning: 'Any previous primary {{contactTypeLabel}} will no longer work during the login process.',
        verifyDescriptionPrefix: 'We will send a verification link to',
        verifyDescriptionSuffix: 'Please enter your password to continue.',
        passwordPlaceholder: 'Enter current password',
        submit: 'Submit',
        emailLabel: 'email',
        phoneLabel: 'phone number',
        emailTypeLabel: 'email address',
        phoneTypeLabel: 'phone number',
      },
      removeModal: {
        emailTitle: 'Remove Email Address',
        mobileTitle: 'Remove Mobile Number',
        heading: 'Are you sure?',
        descriptionPrefix: 'Are you sure you want to remove',
        passwordPlaceholder: 'Enter current password',
      },
      verificationSentModal: {
        titlePart1: 'A verification link has been',
        sentToEmail: 'sent to your email',
        sentToPhone: 'sent to your phone',
        description: 'Please click on that link to verify',
        verifyNow: 'Verify Now',
      },
    },
    changePassword: {
      title: 'Change Password',
      oldPassword: 'Old Password',
      newPassword: 'New Password',
      confirmPassword: 'Confirm Password',
      buttons: {
        saveChanges: 'Save Changes',
      },
      errors: {
        oldPasswordRequired: 'Old password is required.',
        newPasswordRequired: 'New password is required.',
        confirmPasswordRequired: 'Confirm password is required.',
        confirmPasswordMismatch: 'Both passwords should match.',
        invalidPassword: 'Please enter valid password.',
      },
      successMessages: {
        passwordChanged: 'Password changed successfully.',
      },
    },
    createPassword: {
      title: 'Create Password',
      newPassword: 'New Password',
      confirmPassword: 'Confirm Password',
      buttons: {
        createPassword: 'Create Password',
      },
      errors: {
        newPasswordRequired: 'New password is required.',
        confirmPasswordRequired: 'Confirm password is required.',
        confirmPasswordMismatch: 'Both passwords should match.',
        invalidPassword: 'Please enter valid password.',
      },
      successMessages: {
        passwordCreated: 'Password created successfully.',
      },
    },
    successMessages: {
      profileUpdated: 'Profile information updated successfully',
    },
    signature: {
      sectionTitle: 'Signature',
      addSignature: 'Add Signature',
      editSignature: 'Edit Signature',
      save: 'Save Signature',
    },
  },
  personalInformation: {
    errors: {
      allergiesRequired: 'Please specify any allergies or select "None"',
      dateOfBirthRequired: 'Date of birth is required',
      ethnicityRequired: 'Ethnicity is required',
      firstNameMax: 'First name cannot exceed 50 characters',
      firstNameMin: 'First name must be at least 2 characters',
      firstNameRequired: 'First name is required',
      genderRequired: 'Gender is required',
      idImageRequired: 'Government ID image is required',
      idNumberMax: 'ID number cannot exceed 20 characters',
      idNumberMin: 'ID number must be at least 4 characters',
      idNumberRequired: 'ID number is required',
      idTypeRequired: 'ID type is required',
      invalidSSN: 'Please enter valid last 4 digits of SSN',
      issuedByRequired: 'Issuing authority is required',
      lastNameMax: 'Last name cannot exceed 50 characters',
      lastNameMin: 'Last name must be at least 2 characters',
      lastNameRequired: 'Last name is required',
      lastSSNRequired: 'Last 4 digits of SSN are required',
      middleNameMax: 'Middle name cannot exceed 50 characters',
      middleNameRequired: 'Middle name is required',
      primaryLanguageRequired: 'Primary language is required',
      veteranStatusRequired: 'Veteran status is required',
      profilePictureRequired: 'Profile picture is required',
    },
    profilePhoto: 'Profile Photo',
    govtId: {
      idImage: 'ID Image',
      idNumber: 'ID Number',
      idType: 'ID Type',
      issuedBy: 'Issued By',
      title: 'Government Issued ID',
    },
    next: 'Next: Contact Information',
    personalInformation: {
      allergies: 'Allergies',
      dateOfBirth: 'Date of Birth',
      ethnicity: 'Ethnicity',
      firstName: 'First Name',
      gender: 'Gender',
      lastName: 'Last Name',
      lastSSN: 'Last 4 SSN',
      middleName: 'Middle Name',
      primaryLanguage: 'Primary Language',
      title: 'Personal Information',
      veteran: 'Veteran',
      veteranStatus: 'Veteran Status',
    },
    skippable: {
      asterisk: '**',
      isRequiredButSkippableUntil: 'is required but skippable until',
      provideNowOrLater: 'You can provide this information now or do it later.',
      requiredButSkippable: 'required but skippable',
      skippableTill: {
        badgeActivation: 'Badge Activation',
        badgePrinting: 'Badge Printing',
        consentForm: 'Consent Form',
        notSet: 'Not Set',
      },
    },
    subtitle: 'Enter your personal Information',
    title: 'Personal Information',
  },
  piiPinVerificationModals: {
    enterPin: 'Please enter the PIN that was sent to',
    infoText:
      'The data in this field is Personably Identifiable Information. To edit, you must confirm your identity by providing a PIN sent to your primary contact method.',
    receivePin: 'Would you like to receive a PIN?',
    resendPin: 'Resend PIN',
    title: 'Additional Information Needed',
  },
  projectList: {
    actions: {
      addEmployer: 'Add Employer',
      decline: 'Decline',
      myCertifications: 'My Certifications',
      myCourses: 'My Courses',
      register: 'Register',
      sort: 'Sort',
      viewDocuments: 'View Documents',
      viewEBadge: 'View E-Badge',
      viewProfile: 'View Profile',
    },
    declineConfirmationModal: {
      message: 'You are about to decline your project from',
      title: 'Are you sure?',
    },
    declineProject: 'Decline {{value}}',
    eBadgeModal: {
      noData: 'No badge data available',
      placeholder: 'Please select a company to view the e-badge.',
      selectCompany: 'Select Company',
      title: 'E-Badge',
    },
    emptyState: {
      all: {
        subtitle: "You don't have any projects yet. Once you join or get invited to projects, they will appear here.",
        title: 'No Projects Found',
      },
      current: {
        subtitle: "You don't have any active projects right now. Start working on a project to see it here.",
        title: 'No Current Projects',
      },
      default: {
        subtitle: 'There are no projects to display at this time.',
        title: 'No Projects Available',
      },
      past: {
        subtitle: "You haven't completed any projects yet. Your finished projects will be shown here.",
        title: 'No Past Projects',
      },
      pending: {
        subtitle: "You don't have any pending projects at the moment. New project invitations will appear here.",
        title: 'No Pending Projects',
      },
      noProjects: 'No Items Available',
    },
    errors: {
      registrationErrorBadgeRevoked: 'Registration cannot be completed, badge has been revoked',
    },
    selectCompanies: 'Select Companies',
    sort: {
      dateNewToOld: 'Sort By Date: New to Old',
      dateOldToNew: 'Sort By Date: Old to New',
      nameAtoZ: 'Sort By Name: A to Z',
      nameZtoA: 'Sort By Name: Z to A',
    },
    status: {
      current: 'CURRENT PROJECT',
      past: 'PAST PROJECT',
      pending: 'PENDING PROJECT',
    },
    tabs: {
      all: 'All Projects',
      current: 'Current Projects',
      past: 'Past Projects',
      pending: 'Pending Projects',
    },
    title: 'My Projects',
    viewMissingRequirements: 'View missing requirements!',
    missingRequirementsModal: {
      title: 'Missing Requirements',
      itemRequired: '{{count}} item required',
      itemsRequired: '{{count}} items required',
      showDetails: 'Show Details',
      hideDetails: 'Hide Details',
      noteLabel: 'Note:',
      badge: {
        missing: 'MISSING',
      },
      certifications: {
        title: 'Missing / Expired Certifications',
        link: 'Go to My certifications',
      },
      courses: {
        title: 'Missing / Expired Courses',
        link: 'Go to My courses',
      },
      trainings: {
        title: 'Missing / Expired Trainings',
      },
      upcomingCertifications: {
        title: 'Upcoming Certifications Requirements',
        note: 'Must be added within 45 days from badge activation.',
      },
      upcomingCourses: {
        title: 'Upcoming Courses Requirements',
        note: 'Must be added within 45 days from badge activation.',
      },
      upcomingTrainings: {
        title: 'Upcoming Trainings Requirements',
        note: 'Must be added within 45 days from badge activation.',
      },
      note: {
        gracePeriodPreactive: 'Must be added within {{days}} days from badge activation and before the mandatory date of {{date}}',
        effectiveFrom: 'Effective from {{date}}',
        gracePeriod: 'Must be added within {{days}} days from badge activation.',
      },
    },
  },
  resetPassword: {
    buttons: {
      backToLogin: 'Back to Login',
      backToSignIn: 'Go back to Sign-In',
      sendOneTimePassword: 'Send One-Time Password',
      sendResetLink: 'Send Reset Link',
    },
    email: 'Email',
    errors: {
      emailRequired: 'Email is required.',
      invalidEmail: 'Please enter a valid Email.',
      invalidPhoneNumber: 'Please enter a valid Mobile Number.',
      phoneNumberRequired: 'Mobile Number is required.',
    },
    or: 'or',
    phoneNumber: 'Mobile Number',
    subtitle: 'Enter your registered email id or mobile number.',
    success: {
      title: 'Reset Password link has been sent',
    },
    title: 'Reset Password',
  },
  selectProject: {
    buttons: {
      getStarted: 'Get Started',
    },
    employer: 'Employer',
    errors: {
      employersRequired: 'Please select an employer to proceed.',
      failedToAssignWorkerToCompanies: 'Failed to assign worker to project and companies.',
      positiveDrugTest:
        'You have a positive drug test from {{projectName}} that prevents you from being assigned to this project.',
      positiveDrugTestWithValidity:
        'You have a positive drug test from {{projectName}} that prevents you from being assigned to this project. This positive test result will be valid until {{validUntil}}.',
      projectRequired: 'Please select a project to proceed.',
    },
    fca: 'Field Control Analytics',
    project: 'Project',
    selectEmployer: 'Select Employer',
    selectProject: 'Select Project',
    selectYourEmployer: 'Please select your employer',
    selectYourProject: 'Please select your project',
    employerStatus: {
      notAvailable: 'Not Available',
      suspended: 'Suspended',
    },
    warnings: {
      incompleteWorkers:
        'There are few incomplete workers in <bold>{{projectName}}</bold>. Please complete or delete all the workers before changing the project.',
      loginRequired: 'Please log in or use a QR code to have access to project selection',
      projectNotEnabled: 'This project is currently unavailable. Please contact your supervisor.',
    },
    lockSelectedProject: 'Lock selected project',
    welcome: 'Welcome to',
  },
  signature: {
    clear: 'Clear',
    description:
      'By signing this document with an electronic signature, I agree that such signature will be as valid as handwritten signatures to the extent allowed by local law',
    error: 'Please provide a signature',
    signNext: 'Submit Consent Form',
    title: 'Signature',
  },
  takePhoto: {
    buttons: {
      capture: 'Capture Photo',
      skip: 'Skip',
    },
    instructions: {
      0: {
        text: 'Use grey or neutral background. Remove any hats, hard hats or other PPE',
        title: 'Setup your space',
      },
      1: {
        text: 'Remove any face coverings including masks, all glasses, including prescription, safety and sunglasses.',
        title: 'Remove face coverings',
      },
    },
    subtitle: 'Capture your image',
    title: 'Take a Photo',
    warning: 'Remember that poor image quality will result in delayed access to the job sites',
  },
  trades: {
    addOtherTrade: 'Add other trades',
    errors: {
      laborUnionNumberMax: 'Labor union number cannot exceed 20 characters',
      laborUnionNumberMin: 'Labor union number must be at least 3 characters',
      laborUnionNumberRequired: 'Labor union number is required',
      laborUnionRequired: 'Labor union is required',
      otherTradeMax: 'Other trade description cannot exceed 100 characters',
      roleRequired: 'Role is required',
      selectedTradesMinimum: 'Please select at least one trade',
      selectedTradesRequired: 'At least one trade must be selected',
      workExperienceRequired: 'Work experience is required',
    },
    laborUnion: 'Labor Union',
    laborUnionNumber: 'Labor Union Number',
    next: 'Next: Certifications',
    otherTrade: 'Other Trade',
    role: 'Role',
    selectedTrades: 'Select Trades',
    subtitle: 'Enter your trades',
    title: 'Trades',
    workExperience: 'Work Experience',
  },
  verifyOtp: {
    buttons: {
      verifyAccount: 'Verify Account',
    },
    errors: {
      invalidOtp: 'The OTP entered is incorrect. Please try again.',
      otpRequired: 'Please enter your one-time password.',
    },
    subtitle: 'Please enter the OTP that was sent to <bold>{{destination}}</bold>',
    title: 'Enter your one-time password',
  },
  welcomeModal: {
    assignedTo: {
      part1: 'You are now assigned to',
    },
    bullets: {
      certifications: {
        link: 'My Certifications',
        part1: 'This project requires that you upload specific certifications. Upload your certifications on the',
        part2: 'page.',
      },
      courses: {
        link: 'My Courses',
        part1: 'This project requires that you complete specific courses. Access required courses on the',
        part2: 'page.',
      },
      drugTesting: {
        link: 'here',
        part1: 'This project requires workers to undergo drug testing. Schedule appointments for required drug tests',
      },
      workerProfile: {
        link: 'Worker Profile',
        part1: 'Go to your',
        part2: 'to edit your information, view assignments, and access your badges.',
      },
    },
    description: 'To complete your registration and have your badge activated:',
    loginLink: 'Access',
    loginDescription: 'your Worker Profile to edit your information, view assignments, and access your badges.',
    title: 'Welcome aboard!',
  },
  workerRegistration: {
    email: 'Email',
    errors: {
      emailRequired: 'Email is required.',
      invalidEmail: 'Please enter a valid Email.',
      invalidPhoneNumber: 'Please enter a valid Mobile Number.',
      phoneNumberRequired: 'Mobile Number is required.',
    },
    phoneNumber: 'Mobile Number',
    unverifiedWorkerWarning:
      'You can either provide your contact information now or register as an unverified worker at the jobsite.',
    welcome: 'Welcome!',
  },
  workerStatus: {
    actions: {
      deleteWorker: 'Remove Item',
      editDetails: 'Edit Details',
      selectProject: 'Select Project',
      uploadData: 'Upload Data',
      viewDetails: 'View Details',
    },
    card: {
      createdOn: 'Created On',
      email: 'Email',
      lastUpdatedOn: 'Last Updated On',
      mobileNumber: 'Mobile Number',
      projectName: 'Project Name',
    },
    deleteWorkerModal: {
      message: 'Are you sure you want to remove this worker from the list?',
      title: 'Are you sure?',
    },
    emptyState: {
      completed: {
        subtitle: "You don't have any completed workers.",
        title: 'No Completed Workers',
      },
      default: {
        subtitle: 'There are no workers to display at this time.',
        title: 'No Workers Available',
      },
      incomplete: {
        subtitle: "You don't have any incomplete workers.",
        title: 'No Incomplete Workers',
      },
      pending: {
        subtitle: "You don't have any pending workers.",
        title: 'No Pending Workers',
      },
      processing: {
        subtitle: "You don't have any processing workers.",
        title: 'No Processing Workers',
      },
    },
    errors: {
      registrationNotCompleted: 'Registration cannot be completed',
    },
    profileWarningModal: {
      buttonText: 'Update Now',
      pleaseComplete: 'Please complete',
      pleaseUpload: 'Please upload the worker',
      title: 'Pending Profile Update',
    },
    tabs: {
      completed: 'Completed',
      incomplete: 'Incomplete',
      pending: 'Pending',
      processing: 'Processing',
    },
    title: 'Worker Status',
    warningMessage:
      'Completed workers will be displayed for 24 hours. Pending and Incomplete workers will be displayed for 14 days.',
  },
  workerStatusLoginModal: {
    invalidPinError: 'Invalid PIN',
    title: 'Please enter PIN',
  },
  PageNotFoundMessage: 'There is no page found here.',
  UnAuthorizedMessage: 'You are not authorized to access this page.',
  Warning: 'Warning',
};

export default enTranslation;
